<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-statistics-region'}">{{ $t('monitoringStatisticsDashboard.cards.byRegion') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-statistics-unit'}">{{ $t('monitoringStatisticsDashboard.cards.byDepartment') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-statistics-organization'}">{{ $t('monitoringStatisticsDashboard.cards.byOrganization') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="6">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-statistics-client'}">{{ $t('monitoringStatisticsDashboard.cards.byInternalClients') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="6">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-client-unit-statistics'}">{{ $t('monitoringStatisticsDashboard.cards.byClientBranches') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "MonitoringStatisticsDashboardPage",
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('monitoringStatisticsDashboard.pageTitle'))
  }
}
</script>

<style scoped>

</style>